module.exports = {
	"contractName": "EncryptFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405260008054600160a060020a03191633179055610563806100256000396000f3006080604052600436106100615763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416637726f77681146100665780638da5cb5b14610096578063d38def5b146100ab578063f2fde38b146100e6575b600080fd5b61007a600160a060020a0360043516610109565b60408051600160a060020a039092168252519081900360200190f35b3480156100a257600080fd5b5061007a610136565b3480156100b757600080fd5b506100d2600160a060020a0360043581169060243516610145565b604080519115158252519081900360200190f35b3480156100f257600080fd5b50610107600160a060020a03600435166101d6565b005b600061011361026a565b604051809103906000f08015801561012f573d6000803e3d6000fd5b5092915050565b600054600160a060020a031681565b60008083905080600160a060020a031663a7a1ed726040518163ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401602060405180830381600087803b1580156101a257600080fd5b505af11580156101b6573d6000803e3d6000fd5b505050506040513d60208110156101cc57600080fd5b5051949350505050565b600054600160a060020a031633146101ed57600080fd5b600160a060020a038116151561020257600080fd5b60008054604051600160a060020a03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff1916600160a060020a0392909216919091179055565b6040516102bd8061027b83390190560060806040527f43726f73736c696e6b203230313900000000000000000000000000000000000060005534801561003457600080fd5b50610279806100446000396000f3006080604052600436106100565763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663522e1177811461005b5780639189fec114610084578063a7a1ed721461009e575b600080fd5b34801561006757600080fd5b506100706100b3565b604080519115158252519081900360200190f35b34801561009057600080fd5b5061009c6004356100bc565b005b3480156100aa57600080fd5b50610070610244565b60015460ff1681565b6040805142602080830182905283518084038201815292840193849052825191936000938493849384939182918401908083835b6020831061010f5780518252601f1990920191602091820191016100f0565b51815160209384036101000a60001901801990921691161790526040805192909401829003822042838301819052855180850384018152938601958690528351919b5099509195509293508392850191508083835b602083106101835780518252601f199092019160209182019101610164565b51815160209384036101000a600019018019909216911617905260408051929094018290038220600054438484015285518085038401815293860195869052835191995096509194508392508401908083835b602083106101f55780518252601f1990920191602091820191016101d6565b5181516000196020949094036101000a9390930192831692191691909117905260405192018290039091206001805460ff19169990971816939093169890981495909517909255505050505050565b60015460ff16905600a165627a7a72305820fe4fa0b43e32d7006e621e0e727ccc3aceeed9d9f22f1bbc9d7723c16022fcaf0029a165627a7a723058208b21fb88a2cf5119e68cbf4e8dc93da187be3b1e20d915c57657a5c41b59349a0029",
	"deployedBytecode": "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",
	"sourceMap": "78:344:8:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;78:344:8;;;;;;",
	"deployedSourceMap": "78:344:8:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;115:118;;-1:-1:-1;;;;;115:118:8;;;;;;;;;-1:-1:-1;;;;;115:118:8;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;237:183:8;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;237:183:8;-1:-1:-1;;;;;237:183:8;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;115:118:8;180:7;215:13;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;208:20:8;115:118;-1:-1:-1;;115:118:8:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;237:183:8:-;323:4;350:16;377:9;350:37;;400:8;-1:-1:-1;;;;;400:13:8;;:15;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;400:15:8;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;400:15:8;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;400:15:8;;237:183;-1:-1:-1;;;;237:183:8:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;78:344:8:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./base/Level.sol\";\nimport \"./Encrypt.sol\";\n\ncontract EncryptFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    return new Encrypt();\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    Encrypt instance = Encrypt(_instance);\n    return instance.pass();\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/EncryptFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/EncryptFactory.sol",
		"exportedSymbols": {
			"EncryptFactory": [
				1035
			]
		},
		"id": 1036,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 994,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:8"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 995,
				"nodeType": "ImportDirective",
				"scope": 1036,
				"sourceUnit": 2867,
				"src": "26:26:8",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Encrypt.sol",
				"file": "./Encrypt.sol",
				"id": 996,
				"nodeType": "ImportDirective",
				"scope": 1036,
				"sourceUnit": 993,
				"src": "53:23:8",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 997,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "105:5:8",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 998,
						"nodeType": "InheritanceSpecifier",
						"src": "105:5:8"
					}
				],
				"contractDependencies": [
					992,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1035,
				"linearizedBaseContracts": [
					1035,
					2866,
					2922
				],
				"name": "EncryptFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1011,
							"nodeType": "Block",
							"src": "189:44:8",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1005,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1000,
										"src": "195:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1006,
									"nodeType": "ExpressionStatement",
									"src": "195:7:8"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1008,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "215:11:8",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_Encrypt_$992_$",
												"typeString": "function () returns (contract Encrypt)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1007,
												"name": "Encrypt",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 992,
												"src": "219:7:8",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Encrypt_$992",
													"typeString": "contract Encrypt"
												}
											}
										},
										"id": 1009,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "215:13:8",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Encrypt_$992",
											"typeString": "contract Encrypt"
										}
									},
									"functionReturnParameters": 1004,
									"id": 1010,
									"nodeType": "Return",
									"src": "208:20:8"
								}
							]
						},
						"documentation": null,
						"id": 1012,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1001,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1000,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1012,
									"src": "139:15:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 999,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "139:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "138:17:8"
						},
						"payable": true,
						"returnParameters": {
							"id": 1004,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1003,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1012,
									"src": "180:7:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1002,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "180:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "179:9:8"
						},
						"scope": 1035,
						"src": "115:118:8",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1033,
							"nodeType": "Block",
							"src": "331:89:8",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1021,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1016,
										"src": "337:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1022,
									"nodeType": "ExpressionStatement",
									"src": "337:7:8"
								},
								{
									"assignments": [
										1024
									],
									"declarations": [
										{
											"constant": false,
											"id": 1024,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1034,
											"src": "350:16:8",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Encrypt_$992",
												"typeString": "contract Encrypt"
											},
											"typeName": {
												"contractScope": null,
												"id": 1023,
												"name": "Encrypt",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 992,
												"src": "350:7:8",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Encrypt_$992",
													"typeString": "contract Encrypt"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1028,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1026,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1014,
												"src": "377:9:8",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1025,
											"name": "Encrypt",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 992,
											"src": "369:7:8",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Encrypt_$992_$",
												"typeString": "type(contract Encrypt)"
											}
										},
										"id": 1027,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "369:18:8",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Encrypt_$992",
											"typeString": "contract Encrypt"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "350:37:8"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 1029,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1024,
												"src": "400:8:8",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Encrypt_$992",
													"typeString": "contract Encrypt"
												}
											},
											"id": 1030,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "pass",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 991,
											"src": "400:13:8",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 1031,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "400:15:8",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1020,
									"id": 1032,
									"nodeType": "Return",
									"src": "393:22:8"
								}
							]
						},
						"documentation": null,
						"id": 1034,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1017,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1014,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1034,
									"src": "263:17:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1013,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "263:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1016,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1034,
									"src": "282:15:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1015,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "282:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "262:36:8"
						},
						"payable": false,
						"returnParameters": {
							"id": 1020,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1019,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1034,
									"src": "323:4:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1018,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "323:4:8",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "322:6:8"
						},
						"scope": 1035,
						"src": "237:183:8",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1036,
				"src": "78:344:8"
			}
		],
		"src": "0:423:8"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/EncryptFactory.sol",
		"exportedSymbols": {
			"EncryptFactory": [
				1035
			]
		},
		"id": 1036,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 994,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:8"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 995,
				"nodeType": "ImportDirective",
				"scope": 1036,
				"sourceUnit": 2867,
				"src": "26:26:8",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Encrypt.sol",
				"file": "./Encrypt.sol",
				"id": 996,
				"nodeType": "ImportDirective",
				"scope": 1036,
				"sourceUnit": 993,
				"src": "53:23:8",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 997,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "105:5:8",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 998,
						"nodeType": "InheritanceSpecifier",
						"src": "105:5:8"
					}
				],
				"contractDependencies": [
					992,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1035,
				"linearizedBaseContracts": [
					1035,
					2866,
					2922
				],
				"name": "EncryptFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1011,
							"nodeType": "Block",
							"src": "189:44:8",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1005,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1000,
										"src": "195:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1006,
									"nodeType": "ExpressionStatement",
									"src": "195:7:8"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1008,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "215:11:8",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_Encrypt_$992_$",
												"typeString": "function () returns (contract Encrypt)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1007,
												"name": "Encrypt",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 992,
												"src": "219:7:8",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Encrypt_$992",
													"typeString": "contract Encrypt"
												}
											}
										},
										"id": 1009,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "215:13:8",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Encrypt_$992",
											"typeString": "contract Encrypt"
										}
									},
									"functionReturnParameters": 1004,
									"id": 1010,
									"nodeType": "Return",
									"src": "208:20:8"
								}
							]
						},
						"documentation": null,
						"id": 1012,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1001,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1000,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1012,
									"src": "139:15:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 999,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "139:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "138:17:8"
						},
						"payable": true,
						"returnParameters": {
							"id": 1004,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1003,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1012,
									"src": "180:7:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1002,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "180:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "179:9:8"
						},
						"scope": 1035,
						"src": "115:118:8",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1033,
							"nodeType": "Block",
							"src": "331:89:8",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1021,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1016,
										"src": "337:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1022,
									"nodeType": "ExpressionStatement",
									"src": "337:7:8"
								},
								{
									"assignments": [
										1024
									],
									"declarations": [
										{
											"constant": false,
											"id": 1024,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1034,
											"src": "350:16:8",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Encrypt_$992",
												"typeString": "contract Encrypt"
											},
											"typeName": {
												"contractScope": null,
												"id": 1023,
												"name": "Encrypt",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 992,
												"src": "350:7:8",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Encrypt_$992",
													"typeString": "contract Encrypt"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1028,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1026,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1014,
												"src": "377:9:8",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1025,
											"name": "Encrypt",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 992,
											"src": "369:7:8",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Encrypt_$992_$",
												"typeString": "type(contract Encrypt)"
											}
										},
										"id": 1027,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "369:18:8",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Encrypt_$992",
											"typeString": "contract Encrypt"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "350:37:8"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 1029,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1024,
												"src": "400:8:8",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Encrypt_$992",
													"typeString": "contract Encrypt"
												}
											},
											"id": 1030,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "pass",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 991,
											"src": "400:13:8",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 1031,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "400:15:8",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1020,
									"id": 1032,
									"nodeType": "Return",
									"src": "393:22:8"
								}
							]
						},
						"documentation": null,
						"id": 1034,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1017,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1014,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1034,
									"src": "263:17:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1013,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "263:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1016,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1034,
									"src": "282:15:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1015,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "282:7:8",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "262:36:8"
						},
						"payable": false,
						"returnParameters": {
							"id": 1020,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1019,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1034,
									"src": "323:4:8",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1018,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "323:4:8",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "322:6:8"
						},
						"scope": 1035,
						"src": "237:183:8",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1036,
				"src": "78:344:8"
			}
		],
		"src": "0:423:8"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.799Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/EncryptFactory.json
// module id = 1033
// module chunks = 0